export const config = {
    api: "./data-base",

    telegramKafedra: "https://t.me/kafedra",
    telegramChashkin: "https://t.me/Chashkin",
    email: "mail@kafedra.agency",
    emailHref: "mailto:mail@kafedra.agency",
    blogUrl: "http://blog.kafedra.agency/",
    consist:"Consist.pdf",

    dataBase: {
        directionsWork: "/directions-work.json",
        services: "/services.json",
        companiesLogo: "/companies-logo.json",
    },

    directoryPaths: {
        staticImagePath: "./images",
        directions: "/directions",
        services: "/services",
        servicesMobile: "/services/mobile",
        companiesLogo: "/companies-logo"
    },
}